import { useAuth } from "context/auth-context";
import { useTenant } from "hooks/useTenant";
import { useMemo } from "react";

/**
 * Checks permissions to write for specific admin user
 */
export const usePermissions = () => {
  const { identity } = useAuth();
  const { activeTenant } = useTenant();
  const effectivePermissions = useMemo(() => {
    if (!identity) {
      return [];
    }

    const tenantPermissions =
      (activeTenant &&
        identity.tenantInfo &&
        identity.tenantInfo[activeTenant] &&
        identity.tenantInfo[activeTenant].permissions) ||
      [];

    return Array.from(new Set([...identity.permissions, ...tenantPermissions]));
  }, [identity, activeTenant]);

  const canAddPostsAsAdmin = effectivePermissions.includes("post:write-admin");
  const canCreatePosts = effectivePermissions.includes("post:write");
  const canAlwaysCreatePosts = effectivePermissions.includes("post:write-always");
  const canPostAsOrganisation = effectivePermissions.includes("post:write-organisation");
  const canCreateCourses = effectivePermissions.includes("course:write");
  const canReadTags = effectivePermissions.includes("tag:read");
  const canReadNotifications = effectivePermissions.includes("notification:read");
  const canCreateReels = effectivePermissions.includes("reel:write");
  const canEditAllReels = effectivePermissions.includes("reel:write-all");
  const canQueryAllReviews = effectivePermissions.includes("revinst:read-all");
  const canStartReviews = effectivePermissions.includes("revinst:write-all");
  const canReadCalendarEvents = effectivePermissions.includes("calevent:read");

  return {
    canAddPostsAsAdmin,
    canCreatePosts,
    canAlwaysCreatePosts,
    canPostAsOrganisation,
    canCreateCourses,
    canReadTags,
    canReadNotifications,
    canCreateReels,
    canEditAllReels,
    canQueryAllReviews,
    canStartReviews,
    canReadCalendarEvents
  };
};
